import {React} from 'common'
import IconButton from '@mui/material/IconButton'
import {useLanguage} from 'store/Store'
import {Svgs} from 'appearance'

const LanguageMenuButton = ({menuId, handleLanguageMenuOpen}) => {
    const language = useLanguage()?.toLowerCase()
    return (
        <IconButton
            aria-label="account of current user"
            aria-controls={menuId}
            aria-haspopup="true"
            onClick={handleLanguageMenuOpen}
            color="inherit">
            {
                {
                    he: <Svgs.IsraeliFlag width="50" height="50" />,
                    en: <Svgs.AmericanFlag width="50" height="50" />,
                }[language]
            }
        </IconButton>
    )
}

export default LanguageMenuButton
